import { Die } from "../Die";
import { useState } from "react";
import "./index.scss"

const GenerateRandomNum = () => {
   return Math.floor(Math.random()*6)+1;
}
export const DiceRoller = (props) => {
   const [randomNum1,setRandomNum1] = useState(GenerateRandomNum())
   const [randomNum2,setRandomNum2] = useState(GenerateRandomNum())

    return (<div className="main-container">
        <div className="die-container">
            <Die number={randomNum1} />
            <Die number={randomNum2} />
        </div>
        <button onClick={ () => {
            setRandomNum1(GenerateRandomNum())
            setRandomNum2(GenerateRandomNum())
        }}>Roll Dice</button>
    </div>);
}